/** Contact-form option lists, ported from the legacy @console utils/constants. */

export const LANGUAGES = [
  { value: 'vi', label: 'Tiếng Việt (vi)' },
  { value: 'en', label: 'English (en)' },
  { value: 'ja', label: '日本語 (ja)' },
  { value: 'ko', label: '한국어 (ko)' },
  { value: 'zh', label: '中文 (zh)' },
];

export const CUSTOMER_SOURCES = [
  { value: 'form', label: 'Form' },
  { value: 'event', label: 'Event' },
  { value: 'livechat', label: 'Live Chat' },
  { value: 'hotline', label: 'Hotline' },
  { value: 'marketing_approach', label: 'Marketing Approach' },
  { value: 'research', label: 'Research' },
  { value: 'contact', label: 'Contact' },
  { value: 'sale_event', label: 'Sale Event' },
];

export const SERVICE_INTERESTS = [
  'CDN', 'VPS', 'HOSTING', 'VBM', 'TRANSCODING', 'SECUMAIL', 'DOMAIN', 'EMAIL',
  'EMAIL-VPRO', 'COLOCATION', 'WEBSITE', 'STORAGE', 'SSL', 'SERVER',
  'Receive Guard', 'LIVESTREAM', 'VNIS', 'EMAIL-EG', 'LSDN', 'OTHERS',
];
